<script setup lang="ts">
import type { IDrawerLinkListProps } from '../types'
import { formatFileSize } from '@/cms-ui/utils/fileSize'

const props = defineProps<IDrawerLinkListProps>()
</script>

<template>
    <section>
        <VDivider
            v-if="props.topDivider"
            class="mb-md"
        />

        <template
            v-for="(docsItem, index) in items"
            :key="`linklist_item_docs_${index}`"
        >
            <VLinkList
                v-if="docsItem?.file"
                size="MEDIUM"
                data-test="drawer-linklist"
                :link-label="docsItem?.docName"
                target="_blank"
                :href="docsItem?.file?.links?.site?.href"
                leading-icon="document"
                :has-divider="false"
            >
                <template #additionalText>
                    {{ formatFileSize(docsItem?.file?.size, docsItem?.file?.filename) }}
                </template>
            </VLinkList>
        </template>
    </section>
</template>
